module.exports = __webpack_public_path__ + "img/diner.77487839.svg";